module.exports = __webpack_public_path__ + "operace-nosu_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-nosu_2_before_tn.jpg
// module id = 1600
// module chunks = 0